import { fetchUserData, fetchFrontendVersion } from '@/api/api.APP_TARGET';

const getUserData = ({ state, commit }) => {
  if (state.promise) return state.promise;
  const fetchPromise = fetchUserData().then((data) => {
    commit('SET_USER_DATA', data);
  });
  commit('SET_PROMISE', fetchPromise);
  return fetchPromise;
};

const setUserData = ({ commit }, payload) => {
  commit('SET_PROMISE', null);
  commit('SET_USER_DATA', payload);
};

// eslint-disable-next-line no-empty-pattern
const getFrontendVersion = ({}) => {
  return fetchFrontendVersion();
};

export default {
  getUserData,
  setUserData,
  getFrontendVersion,
};
